import get from 'transmute/get';
export const getThreadHistories = get('threadHistories');